export enum CATEGORY_CREATION_OPTION {
  UPDATE_CATEGORY_INFORMATION = 'updateCategoryInformation',
}
